import React from "react";
import FormControl from "@material-ui/core/FormControl";
import { InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { map } from "ramda";
import { LibraryTypes } from "../organizationServices";
import PropTypes from "prop-types";

const LibraryTypeSelect = props => {
  const { onChange, value, error, helperText, onBlur } = props;

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="library-type">Library Type</InputLabel>
      <Select
        value={value || ""}
        onChange={onChange}
        inputProps={{
          name: "library-type",
          id: "library-type",
        }}
        error={error}
        helperText={helperText}
        onBlur={onBlur}
      >
        {map(lt => {
          return (
            <MenuItem value={lt.libraryTypeId} key={lt.libraryTypeId}>
              {lt.name}
            </MenuItem>
          );
        }, LibraryTypes)}
      </Select>
    </FormControl>
  );
};

LibraryTypeSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default LibraryTypeSelect;
